module.exports = __webpack_public_path__ + "img/why-choose-bg-900-735.2ad797f.jpg";